import React from 'react';
import { Icon } from './Icon.js';
export const IconChartArea2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M5 13H3V21H21V3H19L16 8H13.1429L9 16H7L5 13Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartArea2.js.map